export const STATE_PROP_NAME = 'industryReport'
